<div class="space-y-4 overflow-y-auto">
  <div class="mb-10">
    <a routerLink="" class=""><img class="w-3/4" alt="AngolaEncontra" [src]="'/assets/img/logo_preto.svg'"/></a>
  </div>

  <div class="space-y-10">
    <details open>
      <summary class="font-semibold text-sm"> Utilizador</summary>
      <ul class="mt-2 space-y-5 px-2 text-sm text-gray-500">

        <li (click)="onNavigationClicked()"><i class="pi pi-user mr-2"></i>
        <a routerLink="/perfil" class="hover:text-blue-500">Gestão de Conta</a></li>

        <li (click)="onNavigationClicked()"><i class="pi pi-folder mr-2"></i>
        <a routerLink="/perfil/gestao-ocorrencias" class="hover:text-blue-500">Gestão de Ocorrências</a></li>

        <li (click)="onNavigationClicked()"><i class="pi pi-file mr-2"></i>
        <a routerLink="/perfil/ocorrencias" class="hover:text-blue-500">Minhas Ocorrências</a></li>

        @if (isNormal) {
          <li (click)="onNavigationClicked()"><i class="pi pi-phone mr-2"></i>
          <a routerLink="/perfil/pedidos-contacto" class="hover:text-blue-500">Meus Pedidos de Contacto</a>
        </li>
      }

    </ul>
  </details>

  @if (isPrivileged) {
    <details open>
      <summary class="font-semibold text-sm">Moderador</summary>
      <ul class="mt-2 space-y-5 px-2 text-sm text-gray-500">
        <li (click)="onNavigationClicked()"><i class="pi pi-file-import mr-2"></i>
        <a routerLink="/admin/novas-ocorrencias" class="hover:text-blue-500">Novas Ocorrências</a></li>
        <li (click)="onNavigationClicked()"><i class="pi pi-file mr-2"></i>
        <a routerLink="/admin/todas-ocorrencias" class="hover:text-blue-500">Todas Ocorrências</a></li>
        <li (click)="onNavigationClicked()"><i class="pi pi-file-excel mr-2"></i>
        <a routerLink="/admin/por-remover-ocorrencias" class="hover:text-blue-500">Ocorrências Por Remover</a></li>
        <li (click)="onNavigationClicked()"><i class="pi pi-megaphone mr-2"></i>
        <a routerLink="/admin/reclamacoes" class="hover:text-blue-500">Reportados</a>
      </li>
      @if (isAdmin || isMaster) {
        <li (click)="onNavigationClicked()"><i class="pi pi-inbox mr-2"></i>
        <a routerLink="/admin/feedbacks" class="hover:text-blue-500">Feedbacks</a>
      </li>
    }
  </ul>
</details>
}

@if (isPrivileged) {
  <details open>
    <summary class="font-semibold text-sm">Gestão de Utilizadores</summary>
    <ul class="mt-2 space-y-5 px-2 text-sm text-gray-500">
      @if (isMaster) {
        <li (click)="onNavigationClicked()"><i class="pi pi-lock mr-2"></i>
        <a routerLink="/admin/privilegios" class="hover:text-blue-500">Gestão de Privilégios</a>
      </li>
    }
    <li (click)="onNavigationClicked()"><i class="pi pi-users mr-2"></i>
    <a routerLink="/admin/utilizadores" class="hover:text-blue-500">Todos Utilizadores</a></li>
    <li (click)="onNavigationClicked()"><i class="pi pi-ban mr-2"></i>
    <a routerLink="/admin/utilizadores-bloqueados" class="hover:text-blue-500">Utilizadores Bloqueados</a></li>
  </ul>
</details>
}

</div>

</div>
